import React from "react";
import CountUp from "react-countup";

export default function Achievements() {
  return (
    <>
      {/* ------------------ OUR ACHIEVEMENTS SECTION ------------------ */}
      <div className="bg-gray-100 w-full py-16 px-5">
        <div className="max-w-screen-xl mx-auto px-5">
          {/* Heading */}
          <h3 className="text-3xl font-semibold text-center text-gray-900">
            Our Achievements
          </h3>

          {/* Underline */}
          <div className="bg-red-600 h-1 w-[220px] md:w-[280px] mx-auto mt-3 mb-12 rounded-full"></div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Cars Sold */}
            <div className="p-8 bg-white rounded-xl shadow hover:shadow-lg transition-all duration-300">
              <h3 className="text-4xl font-bold text-gray-900 text-center">
                <CountUp duration={5} end={30000} />+
              </h3>
              <div className="flex items-center justify-center gap-2 mt-2">
                <div className="bg-red-600 h-2 w-2 rounded-full"></div>
                <span className="text-gray-600  text-lg ">Happy Customers</span>
              </div>
            </div>

            {/* Cars Serviced */}
            <div className="p-8 bg-white rounded-xl shadow hover:shadow-lg transition-all duration-300">
              <h3 className="text-4xl font-bold text-gray-900 text-center">
                <CountUp duration={5} end={15} />+
              </h3>
              <div className="flex items-center justify-center gap-2 mt-2">
                <div className="bg-red-600 h-2 w-2 rounded-full"></div>
                <span className="text-gray-600  text-lg ">
                  Number of Touch Points
                </span>
              </div>
            </div>

            {/* Happy Customers */}
            <div className="p-8 bg-white rounded-xl shadow hover:shadow-lg transition-all duration-300">
              <h3 className="text-4xl font-bold text-gray-900 text-center">
                <CountUp duration={5} end={18} />+{" "}
                <span className="text-sm">years</span>
              </h3>
              <div className="flex items-center justify-center gap-2 mt-2">
                <div className="bg-red-600 h-2 w-2 rounded-full"></div>
                <span className="text-gray-600  text-lg">
                  Successfully running
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------------- END SECTION ---------------- */}
    </>
  );
}
